import { PessoaBaseModel } from './../../../core/models/pessoa.model';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { EnumDataset } from '../../../core/enums/enum-dataset';
import { getEnumValues } from '../../../core/tools/helper.tools';
import { EnumSimNao } from '../../../core/enums/enum-simnao';
import { EnumSistemas } from '../../../core/enums/enum-sistemas';
import { SpeedDialModule } from 'primeng/speeddial';
import { TableModule } from 'primeng/table';
import { ListarPessoaModel } from '../models/listar-pessoa.model';
import { MenuItem } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { GestaoPessoaService } from '../service/pessoa.service';
import { TitleComponent } from '../../../core/componentes/Title/title.component';
import "../../../core/tools/string.extensions";

@Component({
  selector: 'app-listar-pessoas',
  templateUrl: './listar-pessoas.gestao.html',
  styleUrl: './listar-pessoas.gestao.scss',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    InputTextModule,
    FloatLabelModule,
    ReactiveFormsModule,
    DropdownModule,
    InputMaskModule,
    SpeedDialModule,
    TableModule,
    ToastModule,
    TagModule,
    TitleComponent
  ],
})
export class ListarPessoaGestao implements OnInit {
  public translate = inject(TranslateService);
  constructor(private formBuilder: FormBuilder, private router: Router) {}

  //#region Service
  pessoaService = inject(GestaoPessoaService);
  //#endregion

  //#region Inicialização
  token: string = sessionStorage.getItem(EnumDataset.dataSetLogin) || '';
  value: string = '';
  filtroForm: FormGroup = this.initFormulario();
  simNaoConst = getEnumValues(EnumSimNao);
  sistemasConst = getEnumValues(EnumSistemas);
  pessoas: ListarPessoaModel[] = [];
  items: MenuItem[] | null = this.preencheBotoes();

  initFormulario() {
    this.filtroForm = this.formBuilder.group({
      nome: [''],
      telefone: [''],
      email: [''],
      sistema: [''],
      status: [''],
    });

    return this.filtroForm;
  }
  ngOnInit() {
    this.buscarPessoas();

    const pessoa1: string = 'tesTe';
    const pessoa2: string = '';

    console.log(pessoa1.StringIsNullOrEmpty()); // false
    console.log(pessoa2.StringIsNullOrEmpty()); // true

  }

  preencheBotoes() {
    this.items = [
      {
        icon: 'pi pi-trash',
        command: () => {},
      },
      {
        icon: 'pi pi-upload',
        routerLink: ['/fileupload'],
      },
      {
        icon: 'pi pi-external-link',
        target: '_blank',
        url: 'http://angular.io',
      },
    ];
    return this.items;
  }
  buscarPessoas() {
    const filtros = this.filtroForm.value;
    console.log(filtros);
    // Dados iniciais (seu mock de exemplo)
    this.pessoaService.buscarPessoas(filtros).then((data) => {
      this.pessoas = data;
    });
  }

  //#endregion

  //#region Actions

  selectPessoa(pessoa: ListarPessoaModel) {
    this.router.navigate(['/pessoa', pessoa.id]);

  }

  //#endregion
}
